export function LoadingState({ label = "Loading" }: { label?: string }) {
  return (
    <div className="loading-state" role="status">
      <span className="loading-state__line" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
